import { Component, OnInit } from '@angular/core';
import { LayoutSettingsService } from 'app/core/services/layout-settings.service';
import { PermissionsService } from '@shared';
import { Store } from '@ngrx/store';
import { SpecializationsState } from '../core/store/specializations/specializations.reducer';
import { loadSpecializations } from '../core/store/specializations/specializations.actions';
import { loadUserTypes } from '../core/store/userTypes/userTypes.actions';
import { WorkAreaState } from '@app/core/store/workarea/workArea.reducer';
import { loadWorkArea } from '@app/core/store/workarea/workArea.actions';
import { ColorsEffect } from '@app/core/store/effectsIndex';
import { loadColors } from '@app/core/store/colors/colors.actions';
import { ToastrService } from 'ngx-toastr';
import { PermissionsState } from '@app/core/store/permissions/permissions.reducer';
import { CurrentUserState } from '@app/core/store/currentUser/currentUser.reducer';
import { loadCurrentUser } from '@app/core/store/currentUser/currentUser.actions';
import { loadAdminType } from '@app/core/store/adminType/adminType.actions';
import { AdminTypeState } from '@app/core/store/adminType/adminType.reducer';
import { loadCities } from '@app/core/store/cities/cities.actions';
import { pendingCountsState } from '@app/core/store/pendingCounts/pendingCounts.reducer';
import { loadPendingCounts } from '@app/core/store/pendingCounts/pendingCounts.actions';
import { DictionaryState } from '@app/core/store/dictionary/dictionary.reducer';
import { loadDictionary } from '@app/core/store/dictionary/dictionary.actions';
import { AdminNotificationsService } from '@app/core/services/admin-notifications.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationsPromptComponent } from './notifications-prompt/notifications-prompt.component';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
  layoutType!: string;
  constructor(
    private _adminNotifications: AdminNotificationsService,
    private _modal: NgbModal,
    private _layout: LayoutSettingsService,
    private _permissionService: PermissionsService,
    private _toast: ToastrService,
    private _store: Store<{
      specializations: SpecializationsState;
      workArea: WorkAreaState;
      colors: ColorsEffect;
      permissions: PermissionsState;
      currentUser: CurrentUserState;
      adminType: AdminTypeState;
      pendingCounts: pendingCountsState;
      dictionary: DictionaryState;
    }>,
  ) {}

  ngOnInit(): void {
    this._layout.setDefaultOptions();
    this.setPermissions();
    this.loadData();
    // sound + browser notification for a job / post / invoice waiting for the admin
    this._adminNotifications.start();
    // explain + ask, once the dashboard has settled
    setTimeout(() => {
      if (this._adminNotifications.shouldPrompt() && !this._modal.hasOpenModals()) {
        this._modal.open(NotificationsPromptComponent, { centered: true, backdrop: 'static', size: 'md' });
      }
    }, 2500);
  }

  loadData() {
    const actions = [
      loadSpecializations(),
      loadUserTypes(),
      loadWorkArea(),
      loadColors(),
      loadCurrentUser(),
      loadAdminType(),
      loadCities(),
      loadPendingCounts(),
      loadDictionary(),
    ];

    actions.forEach((action) => this._store.dispatch(action));
  }

  setPermissions() {
    this._permissionService.getAllPermissions().subscribe({
      next: (response) => {
        if (response.status) {
          this._permissionService.setPermissions(response.data);
        } else {
          this._toast.error(response.message);
        }
      },
      error: (error) => {
        this._toast.error(error);
      },
    });
  }
}
